































import { mapGetters } from "vuex";
import { App } from "@/utils/constants";
export default {
  name: "AttendanceChannel",
  data() {
    return {
      App,
      cards: [
        {
          text: App.Channel.HELP_CENTER,
          icon: "help-circle",
          link: "https://suite.seplag.ce.gov.br/"
        },
        {
          text: "(85) 3125-8056<br>(85) 3125-8057",
          icon: "phone",
          link: "tel:+558531258056"
        },
        {
          text: App.Channel.WHATSAPP_ATTENDANCE,
          icon: "whatsapp",
          circle: true,
          link: "https://wa.me/558531080123"
        },
        {
          text: App.Channel.EMAIL_ATTENDANCE,
          icon: "email",
          link: "mailto:suite.atendimento@seplag.ce.gov.br"
        }
      ]
    };
  },

  computed: {
    ...mapGetters({ isContrast: "isContrast" })
  }
};
